import { render } from "./CompanyInfoValue.vue?vue&type=template&id=3c722f5a&scoped=true&ts=true"
import script from "./CompanyInfoValue.vue?vue&type=script&lang=ts"
export * from "./CompanyInfoValue.vue?vue&type=script&lang=ts"

import "./CompanyInfoValue.vue?vue&type=style&index=0&id=3c722f5a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c722f5a"]])

export default __exports__